import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-booking',
  templateUrl: './booking.component.html',
  styles: [],
  standalone: false
})
export class BookingComponent implements OnInit {
  typeBoat = 0
  adults = 0
  boys = 0
  babies = 0
  dataToDisplay = '30/06/2026 - 01/07/2026'
  startDate = ''
  endDate = ''
  phase = 1
  selectedShip :any
  ships: any[] = [
    {price:100,requirePaper:true,title:'MV 500 COMFORT n.1',img:'./assets/shipPlaceholder.png',desc:'Descrizione molto dettagliata della barca'},
    {price:100,requirePaper:true,title:'MV 500 COMFORT n. 2',img:'./assets/shipPlaceholder.png',desc:'Gommone / 4 posti / Senza patente nautica'},
    {price:100,requirePaper:true,title:'MV570 COMFORT n. 3',img:'./assets/shipPlaceholder.png',desc:'Gommone / 4 posti / Senza patente nautica'},
    {price:100,requirePaper:true,title:'Jenny',img:'./assets/shipPlaceholder.png',desc:'Gommone / 4 posti / Senza patente nautica'},
    {price:100,requirePaper:true,title:'Thousand Sunny',img:'./assets/shipPlaceholder.png',desc:'Gommone / 4 posti / Senza patente nautica'},
    {price:100,title:'Perla Nera',img:'./assets/shipPlaceholder.png',desc:'Gommone / 4 posti / Senza patente nautica'},
    {price:100,title:'Olandese Volante',img:'./assets/shipPlaceholder.png',desc:'Gommone / 4 posti / Senza patente nautica'},
    {price:100,title:'Titanic',img:'./assets/shipPlaceholder.png',desc:'Transatlantico / 3300 posti / Titolo professionale marittimo'},
    {price:100,title:'Costa Concordia',img:'./assets/shipPlaceholder.png',desc:'Gommone / 4 posti / Senza patente nautica'},
  ]

  ngOnInit(): void { }

  add(type: 'adults' | 'boys' | 'babies') {
    let _this = this
    _this[type] = _this[type] + 1
  }

  subtract(type: 'adults' | 'boys' | 'babies') {
    let _this = this
    if (_this[type] > 0) {
      _this[type] = _this[type] - 1
    }
  }

  openStripe(){
    
  }
}
